 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		173: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "bundle-" + ({"0":"mdx/api","1":"mdx/core-concepts","2":"mdx/guides-0x-api-faq","3":"mdx/guides-0x-cheat-sheet","4":"mdx/guides-0x-data-existing-tools","5":"mdx/guides-0x-extensions-explained","6":"mdx/guides-0x-v4-nft-contract-interfaces","7":"mdx/guides-0x-v4-nft-features-overview","8":"mdx/guides-browsing-docs-on-github","9":"mdx/guides-bug-bounty-program","10":"mdx/guides-create-staking-pool","11":"mdx/guides-how-to-set-your-token-allowances","12":"mdx/guides-integrate-instant","13":"mdx/guides-introduction-to-using-0x-liquidity-in-smart-contracts","14":"mdx/guides-legal-guide","15":"mdx/guides-market-making-on-0x","16":"mdx/guides-market-making-on-0x-old","17":"mdx/guides-migrate-0x-api-from-v0-to-v1","18":"mdx/guides-page-template","19":"mdx/guides-relayer-strategies","20":"mdx/guides-rfqt-in-the-0x-api","21":"mdx/guides-setting-up-a-local-0x-testnet","22":"mdx/guides-swap-tokens-with-0x-api","23":"mdx/guides-trading-with-0x-limit-orders","24":"mdx/guides-use-0x-api-liquidity-in-your-smart-contracts","25":"mdx/guides-v2-specification","26":"mdx/guides-v3-specification","27":"mdx/guides-v3-staking-specification","28":"mdx/guides-v3-upgrade-guide","29":"mdx/guides-web3-provider-explained","30":"mdx/guides-zrx-portal-faq","31":"animation/0xApi-json","32":"animation/cexDex-json","33":"animation/depth-json","34":"animation/mesh-json","35":"animation/network-json","36":"animation/onOff-json","37":"animation/switchSpinner-json","38":"animation/switchUnlock-json","39":"icon0","40":"icon1","41":"icon10","42":"icon100","43":"icon101","44":"icon102","45":"icon103","46":"icon104","47":"icon105","48":"icon106","49":"icon107","50":"icon108","51":"icon109","52":"icon11","53":"icon110","54":"icon111","55":"icon112","56":"icon113","57":"icon114","58":"icon115","59":"icon116","60":"icon117","61":"icon118","62":"icon119","63":"icon12","64":"icon120","65":"icon121","66":"icon122","67":"icon123","68":"icon124","69":"icon125","70":"icon126","71":"icon127","72":"icon128","73":"icon129","74":"icon13","75":"icon130","76":"icon131","77":"icon132","78":"icon133","79":"icon134","80":"icon135","81":"icon14","82":"icon15","83":"icon18","84":"icon19","85":"icon2","86":"icon20","87":"icon21","88":"icon22","89":"icon23","90":"icon24","91":"icon25","92":"icon26","93":"icon27","94":"icon28","95":"icon29","96":"icon3","97":"icon30","98":"icon31","99":"icon32","100":"icon33","101":"icon34","102":"icon35","103":"icon36","104":"icon37","105":"icon38","106":"icon39","107":"icon4","108":"icon40","109":"icon41","110":"icon42","111":"icon43","112":"icon44","113":"icon45","114":"icon46","115":"icon47","116":"icon48","117":"icon49","118":"icon5","119":"icon50","120":"icon51","121":"icon52","122":"icon53","123":"icon54","124":"icon55","125":"icon56","126":"icon57","127":"icon58","128":"icon59","129":"icon6","130":"icon60","131":"icon61","132":"icon62","133":"icon63","134":"icon64","135":"icon65","136":"icon66","137":"icon67","138":"icon68","139":"icon69","140":"icon7","141":"icon70","142":"icon71","143":"icon72","144":"icon73","145":"icon74","146":"icon75","147":"icon76","148":"icon77","149":"icon78","150":"icon79","151":"icon8","152":"icon80","153":"icon81","154":"icon82","155":"icon83","156":"icon84","157":"icon85","158":"icon86","159":"icon87","160":"icon88","161":"icon89","162":"icon9","163":"icon90","164":"icon91","165":"icon92","166":"icon93","167":"icon94","168":"icon95","169":"icon96","170":"icon97","171":"icon98","172":"icon99"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 1109);
